export class ProblemTemplate {

    public id: number;
    public name: string;
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/problemTemplate.ts